import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6 12.881V5.12q0-.32.225-.535a.73.73 0 0 1 .722-.187.7.7 0 0 1 .197.084l6.112 3.882a.73.73 0 0 1 .254.28.802.802 0 0 1 0 .713.7.7 0 0 1-.254.282l-6.112 3.88a.8.8 0 0 1-.394.113.73.73 0 0 1-.525-.216.7.7 0 0 1-.225-.534m1.5-1.369L11.438 9 7.5 6.488z"
    }, null, -1)
  ]))]))
}
export default { render: render }